export const normalizeEmailInput = (email: string): string => {
  return email.trim().toLowerCase();
};

export const normalizeEmailIdentifier = (identifier: string): string => {
  const trimmedIdentifier = identifier.trim();
  if (!trimmedIdentifier.includes("@")) {
    return trimmedIdentifier;
  }
  return normalizeEmailInput(trimmedIdentifier);
};
